var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRomotorsWebsiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(32,196,203)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.961 77.885 C 25.44 77.885 12 64.444 12 47.924 c 0 -16.521 13.44 -29.961 29.961 -29.961 s 29.961 13.44 29.961 29.961 C 71.922 64.444 58.481 77.885 41.961 77.885 z M 41.961 22.962 C 28.197 22.962 17 34.16 17 47.924 s 11.197 24.961 24.961 24.961 s 24.961 -11.197 24.961 -24.961 S 55.725 22.962 41.961 22.962 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,167,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.961 77.885 c -8.055 0 -12.269 -15.072 -12.269 -29.961 c 0 -14.889 4.214 -29.961 12.269 -29.961 s 12.27 15.072 12.27 29.961 C 54.23 62.813 50.016 77.885 41.961 77.885 z M 41.961 22.962 c -2.467 0 -7.269 8.811 -7.269 24.961 c 0 16.15 4.802 24.961 7.269 24.961 s 7.27 -8.811 7.27 -24.961 C 49.23 31.773 44.428 22.962 41.961 22.962 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,167,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.961 60.192 C 27.072 60.192 12 55.979 12 47.924 c 0 -8.055 15.072 -12.27 29.961 -12.27 s 29.961 4.214 29.961 12.27 C 71.922 55.979 56.85 60.192 41.961 60.192 z M 41.961 40.654 c -16.15 0 -24.961 4.802 -24.961 7.27 c 0 2.467 8.811 7.269 24.961 7.269 s 24.961 -4.802 24.961 -7.269 C 66.922 45.457 58.111 40.654 41.961 40.654 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,167,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.039 74.807 c -16.521 0 -29.961 -13.44 -29.961 -29.961 c 0 -16.521 13.44 -29.961 29.961 -29.961 S 75 28.325 75 44.845 C 75 61.366 61.56 74.807 45.039 74.807 z M 45.039 19.884 c -13.764 0 -24.961 11.197 -24.961 24.961 c 0 13.764 11.197 24.961 24.961 24.961 S 70 58.609 70 44.845 C 70 31.082 58.803 19.884 45.039 19.884 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.039 74.807 c -8.055 0 -12.27 -15.072 -12.27 -29.961 c 0 -14.889 4.214 -29.961 12.27 -29.961 c 8.055 0 12.27 15.072 12.27 29.961 C 57.309 59.734 53.094 74.807 45.039 74.807 z M 45.039 19.884 c -2.467 0 -7.27 8.811 -7.27 24.961 c 0 16.151 4.802 24.961 7.27 24.961 c 2.468 0 7.27 -8.811 7.27 -24.961 C 52.309 28.695 47.507 19.884 45.039 19.884 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.039 57.114 c -14.889 0 -29.961 -4.214 -29.961 -12.269 c 0 -8.055 15.072 -12.269 29.961 -12.269 S 75 36.791 75 44.845 C 75 52.9 59.928 57.114 45.039 57.114 z M 45.039 37.576 c -16.15 0 -24.961 4.802 -24.961 7.269 s 8.811 7.269 24.961 7.269 S 70 47.313 70 44.845 S 61.189 37.576 45.039 37.576 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomotorsWebsiteIcon);
export default __webpack_public_path__ + "static/media/romotors-website-icon.785716ec.svg";
export { ForwardRef as ReactComponent };